<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cacheViews">
        <router-view :key="key"></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapGetters([
      'permission_routers',
      'cacheViews'
    ]),
    key() {
      return this.$route.fullPath
    },
  },
  created() {
    this.getCacheViews()
  },
  methods: {
    getCacheViews() {
      let list = []

      deep(this.permission_routers)
      function deep(routers) {
        routers.forEach(route => {
          if (route.meta&&route.meta.noCache==false) {
            let val = route.name
            let result = /(\d+$)/g.exec(val)
            if (result) {
              val = result.input.substr(0,result.index)
            }
            if (list.indexOf(val)==-1) {
              list.push(val)
            }
          }
          if (route.children) {
            deep(route.children)
          }
        });
      }

      // console.log(123123,list)
      this.$store.dispatch('set_cache', list)
    }
  },
}
</script>

<style scoped>
.app-main {
  /*130 = navbar + tags-view+ 顶部间隔 + 底部间隔= 80 +34 + 8 + 8
  96= navbar + tags-view+ 顶部间隔 + 底部间隔= 80 + 8 + 8
  */
  height: calc(100vh - 96px);
  position: relative;
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue